export var ContentAreaPassingStatus;
(function (ContentAreaPassingStatus) {
    ContentAreaPassingStatus["AbovePassing"] = "AbovePassing";
    ContentAreaPassingStatus["NearPassing"] = "NearPassing";
    ContentAreaPassingStatus["BelowPassing"] = "BelowPassing";
})(ContentAreaPassingStatus || (ContentAreaPassingStatus = {}));
//# sourceMappingURL=userCustomTest.model.js.map